import { useCallback, useEffect, useState } from "react";

// 定义计时器状态类型
interface TimerState {
  hours: number;
  minutes: number;
  seconds: number;
}

export function CountUpTimer({
  enabled = true,
  count,
  onChange,
}: {
  enabled?: boolean;
  count?: number;
  onChange?: (value: any) => void;
}) {
  // 计时器状态
  const [timerState, setTimerState] = useState<TimerState>({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // 计时器控制状态
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [startTime, setStartTime] = useState<number>(0);
  const [elapsedTime, setElapsedTime] = useState<number>(count || 0);

  // 格式化时间显示
  const formatTime = useCallback(
    (hours: number, minutes: number, seconds: number): string => {
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
    []
  );

  // 更新计时器显示
  const updateTimerDisplay = useCallback(() => {
    const totalSeconds = Math.floor(elapsedTime / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    setTimerState({ hours, minutes, seconds });
  }, [elapsedTime]);

  // 开始计时器
  const startTimer = useCallback(() => {
    if (!isRunning) {
      const currentTime = Date.now();
      setStartTime(currentTime - elapsedTime);
      setIsRunning(true);
    }
  }, [isRunning, elapsedTime]);

  // 暂停计时器
  const pauseTimer = useCallback(() => {
    if (isRunning) {
      setIsRunning(false);
    }
  }, [isRunning]);

  //   // 重置计时器
  //   const resetTimer = useCallback(() => {
  //     setIsRunning(false);
  //     setElapsedTime(0);
  //     setTimerState({ hours: 0, minutes: 0, seconds: 0 });
  //   }, [isRunning, elapsedTime, timerState, formatTime]);

  // 计时器逻辑
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isRunning) {
      interval = setInterval(() => {
        const timeCount = Date.now() - startTime;
        setElapsedTime(timeCount);
        onChange?.(timeCount);
      }, 10);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isRunning, startTime, onChange]);

  // 更新显示
  useEffect(() => {
    updateTimerDisplay();
  }, [elapsedTime, updateTimerDisplay]);

  useEffect(() => {
    if (enabled) {
      startTimer();
    } else {
      pauseTimer();
    }
  }, [enabled, startTimer, pauseTimer]);

  return (
    <span className={"count-up-timer " + (enabled ? "enabled" : "")}>
      {formatTime(timerState.hours, timerState.minutes, timerState.seconds)}
    </span>
  );
}
